import { motion, useInView } from "framer-motion"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"

const LegalInformation = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  const res = module.tab[0].title.replace(/ /g, "")
  const [tabOption, setTabOption] = useState(res)
  if (module.hideSection === "no") {
    return (
      <section
        className={`general-content ${
          module.extraClass ? ` ${module.extraClass}` : ""
        }`}
        id={module.extraId}
      >
        <div className="container-fluid">
          <div className="bg-white-100 pt-70 pb-120 lgscreen:pt-35 lgscreen:pb-60">
            <motion.div
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
              className="anim"
            >
              <motion.div
                ref={ref}
                initial="hidden"
                animate={isInView || hasPlayed ? "show" : "hidden"}
                variants={sectionShow}
              >
                <motion.div variants={animFade}>
                  <ul className="tabs w-full flex flex-wrap justify-center gap-x-8 gap-y-5 px-20">
                    {module.tab.map((item, i) => {
                      const res = item.title.replace(/ /g, "")
                      return (
                        <li
                          key={i}
                          onClick={() => {
                            setTabOption(res)
                          }}
                          className={`tab-link cursor-pointer text-18 tracking-05em uppercase opacity-50  ${
                            tabOption === res ? "tab-current" : ""
                          }`}
                          data-tab={res}
                          onKeyDown={() => {
                            setTabOption(res)
                          }}
                          aria-hidden="true"
                        >
                          {item.title}
                        </li>
                      )
                    })}
                  </ul>
                </motion.div>
                <div className="accordian-container px-[200px] xlscreen:px-80 mdscreen:px-30 pt-30">
                  {module.tab.map((item, i) => {
                    const res = item.title.replace(/ /g, "")
                    return (
                      <div
                        key={i}
                        id={res}
                        className={`tab-content ${
                          tabOption === res ? "tab-current" : "hidden"
                        }`}
                      >
                        <motion.div
                          variants={animFade}
                          className="general-content-inner content"
                        >
                          {item?.title && <h3>{item.title}</h3>}
                          {item?.details && <>{parse(item.details)}</>}
                        </motion.div>
                      </div>
                    )
                  })}
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>
    )
  }
  return null
}

export default LegalInformation
export const PageLegalInformationFragment = graphql`
  fragment PageLegalInformationFragment on WpPage_Pagecontent_PageContent_LegalInformation {
    extraId
    extraClass
    hideSection
    tab {
      title
      details
    }
  }
`
